<template>
  <div v-if="visible" class="text-result">
    <div class="example card text-center mb-3">
      <div class="card-body">
        {{$t('result.task.context-example')}}
        <b>{{example}}</b>
        {{$t('result.task.previous-list')}}
      </div>
    </div>
    <div class="card mb-3 p-3">
      <context-header :document="document" :text="text"/>
    </div>
    <div class="card">
      <div class="card-body">
        <p class="card-text source-text">{{text.source_text}}</p>
      </div>
    </div>
    <div v-if="text.original" class="card mt-3">
      <div class="card-body text-justify">
        <b>{{$t('result.context.header.task.original')}}:</b><br/>
        {{text.original}}
      </div>
    </div>
  </div>
</template>
<script>
  import {mapState} from 'vuex'
  import ContextHeader from './ContextHeader'

  export default {
    components: {ContextHeader},
    computed: {
      ...mapState({
        visible: s => s.api.resultDisplay === 'task',
        example: s => s.api.result.example,
        document: s => s.api.result.document,
        text: s => s.api.result.text
      })
    }
  }
</script>
<style lang="scss" scoped>
  .source-text {
    white-space: pre-wrap;
  }
</style>
